import React, { useState } from "react";
import { getAuth } from "firebase/auth";
import { getFirestore, doc, setDoc } from "firebase/firestore";

const GameTool = ({ onGameComplete, subjectKey, slug }) => {
  const [showPopup, setShowPopup] = useState(false);

  const handleConfirm = async () => {
    const auth = getAuth();
    const user = auth.currentUser;
    if (!user?.uid) return; // Use uid instead of email

    const db = getFirestore();
    const userDataRef = doc(db, "userData", user.uid); // Use uid

    try {
      await setDoc(
        userDataRef,
        {
          [subjectKey]: {
            [slug]: {
              game: true,
            },
          },
        },
        { merge: true }
      );
      
      // ✅ Trigger star refresh in UI (if passed)
      if (onGameComplete) {
        onGameComplete();
      }
      
    } catch (error) {
      console.error("❌ Error updating game progress:", error);
    }
  };

  const handleGameFinish = () => {
    setShowPopup(true);
  };

  return (
    <>
      {/* Your actual game logic should trigger handleGameFinish when done */}
      <button onClick={handleGameFinish}>Finish Game</button>

      {showPopup && (
        <div style={overlayStyle}>
          <div style={popupStyle}>
            <p>Did you finish playing the game?</p>
            <button onClick={handleConfirm}>Yes</button>
            <button onClick={() => setShowPopup(false)}>No</button>
          </div>
        </div>
      )}
    </>
  );
};

const overlayStyle = {
  position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
  backgroundColor: "rgba(0,0,0,0.6)", zIndex: 1000,
  display: "flex", alignItems: "center", justifyContent: "center",
};

const popupStyle = {
  background: "#fff", padding: 20, borderRadius: 10, textAlign: "center",
};

export default GameTool;
